window.getStoreAvailability = async function (variantId, storefrontKey, storefrontversion) {

  if (!variantId) {
    console.warn("getStoreAvailability(): missing variant id");
    return [];
  }

  const variantGID = variantId.startsWith("gid://")
    ? variantId
    : `gid://shopify/ProductVariant/${variantId}`;

  const query = `
    query getVariantById($variantId: ID!) {
      node(id: $variantId) {
        ... on ProductVariant {
          id
          storeAvailability(first: 250) {
            edges {
              node {
                available
                location {
                  id
                  name
                  storeLocation: metafield(namespace: "custom", key: "store_location") {
                      value
                      reference {
                        ... on Metaobject {
                          handle
                          name: field(key:"name") {
                            value
                          }
                          label: field(key:"label") {
                            value
                          }
                        }
                      }
                  }
                }
                quantityAvailable
              }
            }
          }
          supplierLeadTime: metafield(namespace: "custom", key: "supplier_lead_time") {
            value
          }
          pickupProcessingTime: metafield(
            namespace: "custom"
            key: "pickup_processing_time"
          ) {
            value
          }
          shippingProcessingTime: metafield(
            namespace: "custom"
            key: "shipping_processing_time"
          ) {
            value
          }
        }
      }
    }
  `;

  try {
    const response = await fetch(`/api/${storefrontversion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontKey
      },
      body: JSON.stringify({
        query,
        variables: { variantId: variantGID }
      })
    });

    const result = await response.json();
    return result || [];
  } catch (error) {
    console.error("Error fetching store availability:", error);
    return [];
  }
}
